import React from 'react';
import PropTypes from 'prop-types';

import styles from './Footer.scss';

/* eslint-disable react/prop-types */
export const Footer = ({ footerDescription }) => (
  <div className={`d-flex flex-row ${styles.footer} ${styles.fixed}`}>
    <footer className="d-flex col-12 col-lg-6 justify-content-center p-4">
      <div className="text-center">
        {footerDescription}
      </div>
    </footer>
  </div>
);
/* eslint-enable react/prop-types */

Footer.propTypes = {
  footerDescription: PropTypes.string
};

Footer.defaultProps = {
  footerDescription: ''
};

export default Footer;
